"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("@babel/polyfill");

var _manson = _interopRequireDefault(require("@krad/manson"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var MSEController =
/*#__PURE__*/
function () {
  function MSEController(mimeCodec) {
    var _this = this;

    _classCallCheck(this, MSEController);

    this.appendBuffer = this.appendBuffer.bind(this);

    if ('MediaSource' in window && MediaSource.isTypeSupported(mimeCodec)) {
      _manson.default.debug("browser supports mimecodec: ".concat(mimeCodec));

      this.mimeCodec = mimeCodec;
      this.mediaSource = new window.MediaSource();
      this.mediaSourceURL = URL.createObjectURL(this.mediaSource);
      this.mediaSource.addEventListener('sourceopen', function (e) {
        URL.revokeObjectURL(_this.video.src);
        var mediaSource = e.target;
        _this.sourceBuffer = mediaSource.addSourceBuffer(_this.mimeCodec);

        _this.setVideoCB();
      });
    } else {
      if ('MediaSource' in window) {
        throw "Media Type not supported: ".concat(mimeCodec);
      } else {
        throw "MediaSource not available";
      }
    }
  }

  _createClass(MSEController, [{
    key: "setVideo",
    value: function () {
      var _setVideo = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(video) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  if (video) {
                    _this2.setVideoCB = function () {
                      resolve();
                    };

                    _this2.video = video;
                    video.src = _this2.mediaSourceURL;
                  } else {
                    reject('Video was undefined');
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function setVideo(_x) {
        return _setVideo.apply(this, arguments);
      };
    }()
  }, {
    key: "appendBuffer",
    value: function () {
      var _appendBuffer = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(buffer) {
        var _this3 = this;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  if (_this3.video.error) {
                    reject(_this3.video.error);
                    return;
                  }

                  _this3.sourceBuffer.appendBuffer(buffer);

                  _this3.sourceBuffer.onupdateend = function (e) {
                    _this3.sourceBuffer.onupdateend = undefined;
                    resolve();
                  };
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function appendBuffer(_x2) {
        return _appendBuffer.apply(this, arguments);
      };
    }()
  }, {
    key: "endOfStream",
    value: function endOfStream() {
      this.mediaSource.endOfStream();
    }
  }]);

  return MSEController;
}();

var _default = MSEController;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/distribution/mse-controller.js
// module id = 482
// module chunks = 0